import useUser from "api/services/auth/userUser";
import Container from "components/Container";
import Logo from "components/Logo";
import Spinner from "components/Spinner";
import { LazyMotion, domAnimation } from "framer-motion";
import Navigation from "pages/home/Navigation";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { setUser } from "store/user";

export default function MainLayout() {
  const dispatch = useDispatch();

  const { data, isFetching, isFetched } = useUser();

  useEffect(() => {
    if (isFetched) {
      if (data?.id == null) {
        localStorage.removeItem("user");
        dispatch(setUser(null));
      } else {
        dispatch(setUser(data));
        localStorage.setItem("user", JSON.stringify(data));
      }
    }
  }, [data, isFetched, dispatch]);

  return (
    <LazyMotion features={domAnimation}>
      <main className="h-full">
        <section className="overflow-hidden relative lg:h-full min-h-full p-3 lg:p-6 bg-game-gradient flex items-center justify-center">
          <div className="absolute left-1/2 top-1/2 opacity-5 -translate-x-1/2 -translate-y-1/2">
            <Logo svgProps={{ className: "" }} />
          </div>
          <Container
            p={4}
            className="lg:h-full lg:p-4 bg-slate-200/10 rounded-md shadow-2xl"
          >
            <Navigation />
            {isFetching ? (
              <div className="flex-grow flex items-center justify-center fill-white">
                <Spinner />
              </div>
            ) : (
              <Outlet />
            )}
          </Container>
        </section>
      </main>
    </LazyMotion>
  );
}
